// GENERATED by `npm run icons:sync` — do not edit by hand.
import { createLucideIcon } from 'lucide-react';

export const CheckCircle2 = /*#__PURE__*/ createLucideIcon('CheckCircle2', [ ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }], ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }] ]);
